import { LANGUAGE_MAP } from 'constant/language';
import A4Render from '../components/a4-render';
import ContractHeader from '../components/contract-header';
import ContractTitle from '../components/contract-title';
import {
  ContractLang,
  ContractPrintProduct,
  ContractStyleType,
  ContractType,
} from '../utils';
import CustomerCompanyInfo from '../components/customer-company-info';
import ProductTable from '../components/product-table';
import { getShopConfig } from 'constant/shop';
import NormalContractFooter from './normal-contract-footer';

const NORMAL_CONTRACT_NAME_MAP: Record<
  ContractType,
  Record<ContractLang, string>
> = {
  RECYCLE_CUSTOMER: {
    [LANGUAGE_MAP.JA]: '買取伝票（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Repurchase Receipt(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '二手商品交易合同（副本）',
    [LANGUAGE_MAP.FR]: 'Reçu de rachat (Copie)',
  },
  RECYCLE_STORE: {
    [LANGUAGE_MAP.JA]: '買取伝票',
    [LANGUAGE_MAP.EN]: 'Repurchase Receipt',
    [LANGUAGE_MAP.ZH_CN]: '二手商品交易合同',
    [LANGUAGE_MAP.FR]: 'Reçu de rachat',
  },
  SELL_CUSTOMER: {
    [LANGUAGE_MAP.JA]: '委託伝票（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Consignment Receipt(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '二手商品交易合同（副本）',
    [LANGUAGE_MAP.FR]: 'Reçu de consignation (Copie)',
  },
  SELL_STORE: {
    [LANGUAGE_MAP.JA]: '委託伝票',
    [LANGUAGE_MAP.EN]: 'Consignment Receipt',
    [LANGUAGE_MAP.ZH_CN]: '二手商品交易合同',
    [LANGUAGE_MAP.FR]: 'Reçu de consignation',
  },
};

export const SETTLEMENT_CONTRACT_NAME_MAP: Record<
  ContractType,
  Record<ContractLang, string>
> = {
  RECYCLE_CUSTOMER: {
    [LANGUAGE_MAP.JA]: 'ご清算書（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Settlement Statement(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '结算单（副本）',
    [LANGUAGE_MAP.FR]: 'Relevé de règlement (Copie)',
  },
  RECYCLE_STORE: {
    [LANGUAGE_MAP.JA]: 'ご清算書',
    [LANGUAGE_MAP.EN]: 'Settlement Statement',
    [LANGUAGE_MAP.ZH_CN]: '结算单',
    [LANGUAGE_MAP.FR]: 'Relevé de règlement',
  },
  SELL_CUSTOMER: {
    [LANGUAGE_MAP.JA]: 'ご清算書（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Settlement Statement(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '结算单（副本）',
    [LANGUAGE_MAP.FR]: 'Relevé de règlement (Copie)',
  },
  SELL_STORE: {
    [LANGUAGE_MAP.JA]: 'ご清算書',
    [LANGUAGE_MAP.EN]: 'Settlement Statement',
    [LANGUAGE_MAP.ZH_CN]: '结算单',
    [LANGUAGE_MAP.FR]: 'Relevé de règlement',
  },
};

const NormalContract = ({
  storeId,
  headList,
  contractLang,
  contractType,
  userInfoRenderLineList,
  memberId,
  contractPrintProductList,
  contractStyleType,
  isSettlement,
  signatureImage,
}: {
  storeId: number;
  headList: { label: string; value: string }[];
  contractLang: ContractLang;
  contractType: ContractType;
  userInfoRenderLineList: string[];
  memberId: number;
  contractPrintProductList: ContractPrintProduct[];
  contractStyleType: ContractStyleType;
  isSettlement: boolean;
  signatureImage?: string;
}) => {
  const isStoreCopy =
    contractType === 'RECYCLE_STORE' || contractType === 'SELL_STORE';
  const currencySymbol = getShopConfig(storeId).currency;

  const totalPrice = contractPrintProductList.reduce((total, item) => {
    const price = item.price || 0;
    return total + price;
  }, 0);

  return (
    <A4Render>
      <ContractTitle storeId={storeId} contractStyleType={contractStyleType} />
      <ContractHeader
        headList={headList}
        contractLang={contractLang}
        title={
          isSettlement
            ? SETTLEMENT_CONTRACT_NAME_MAP[contractType][contractLang]
            : NORMAL_CONTRACT_NAME_MAP[contractType][contractLang]
        }
        type={contractType}
        storeId={storeId}
      />
      <CustomerCompanyInfo
        contractType={contractType}
        storeId={storeId}
        userInfoRenderLineList={userInfoRenderLineList}
        contractLang={contractLang}
        memberId={memberId}
        isStoreCopy={isStoreCopy}
      />
      <ProductTable
        styleType={contractStyleType}
        showId={isStoreCopy}
        productList={contractPrintProductList}
        contractLang={contractLang}
        currencySymbol={currencySymbol}
        showPrice={true}
      />
      <NormalContractFooter
        contractType={contractType}
        contractLang={contractLang}
        storeId={storeId}
        currencySymbol={currencySymbol}
        totalPrice={totalPrice}
        contractStyleType={contractStyleType}
        isStoreCopy={isStoreCopy}
        signatureImage={signatureImage}
      />
    </A4Render>
  );
};

export default NormalContract;
